import { OBTENER_REPORTES_SUCCESS, OBTENER_REPORTES_ERROR } from '../constants';

export default function tramitesAutorizaciones(state = {}, action) {
  const newState = { ...state };
  switch (action.type) {
    case OBTENER_REPORTES_SUCCESS:
      newState.reportes = action.data;
      return newState;
    case OBTENER_REPORTES_ERROR:
      newState.reportes = [];
      return newState;
    default:
      return newState;
  }
}
